import React from 'react'

export const Asterisk = () => {
  return (
    <span style={{color:'red'}}>*</span>
  )
}
